import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import {
    HTTP_INTERCEPTORS,
    withInterceptorsFromDi,
    provideHttpClient,
} from '@angular/common/http';
import { TokenInterceptor } from './app/service/core/interceptor.service';
import { LOCALE_ID, importProvidersFrom } from '@angular/core';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { provideRouter } from '@angular/router';
import { AppRoutes } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app/app.component';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { AlterarSenhaGuard } from './app/auth/alterar-senha/alterar-senha-guard';

// Register Portuguese locale
registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            ConfirmDialogModule,
            ButtonModule,
            FontAwesomeModule
        ),
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: APP_BASE_HREF, useValue: '/' },
        provideRouter(AppRoutes),
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        MessageService,
        AlterarSenhaGuard,
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    cssVars: true,
                    darkModeSelector: false || 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'styles, primeng, another-css-library'
                    }
                }
                
            },
            translation: {
                    today: 'Hoje',
                    clear: 'Limpar'
                }
        }),
    ],
}).catch((err) => console.error(err));
